module.exports = __webpack_public_path__ + "img/img_banner_size05.1f19b8d5.svg";